                                             

export const hasNoPrice = (product         )          => {
	const {price, recommendedRetailPrice, unitPrice, distributionChannels} = product;
	const {shipping, mounting, pickup} = distributionChannels;
	return !(price || recommendedRetailPrice || unitPrice || shipping || mounting || pickup);
};

export const hideFractionDigitsForEdge = (priceValue        ) => {
	const significantPriceDigits = Math.round(priceValue).toString().length;
	return {maximumSignificantDigits: significantPriceDigits};
};

export const hasFractionDigits = (priceValue        )          => {
	return priceValue % 1 !== 0;
};
